import { ProductList } from "pages/Inventori/Transaction/AddNewItem/types";
import { createContext, PropsWithChildren, useState } from "react";
import { TransferType } from "../../ItemTransfer/types";
import { ReceivedType } from "../../ItemReceived/types";
import { DataType } from "../../RequestForm/types";
import { DataType as ItemBuildType } from "../../ItemBuild/types";
import { CountList } from "../../ItemCount/type";
import { TableSorting } from "components";
import { ListType } from "../../ItemAdjustment/types";
import { BuildFile } from "../../ItemBuild/RegisterItemsBuild";

type DataItem = ProductList | TransferType | ReceivedType | DataType | CountList | ItemBuildType | ListType | BuildFile;
export type Fillter = {
    dateFrom?: string,
    dateTo?: string,
    approval_status?: string
    transfer_status?: string
    from_location_id?: string
    to_location_id?: string
    received_status?: string
    location_id?: string
    count_status?: string
    source?: string
    group_id?: string
    buy?: boolean
    sell?: boolean
    inv?: boolean
    build?: boolean
    jumlah_item?: number
}


export const DataContext = createContext<{
    data: DataItem[]
    setData: (data: DataItem[]) => void
    fill: Fillter
    setFill: (fill: Fillter) => void
    activeColumn?: TableSorting[]
    setActiveColumn?: (tableActive: TableSorting[]) => void
}>({
    data: [],
    setData: () => {},
    fill: {},
    setFill: () => { },
    activeColumn: [],
    setActiveColumn: () => { }
})

export function DataProvider(params: PropsWithChildren) {
    const [data, setData] = useState<DataItem[]>([]);
    const [activeColumn, setActiveColumn] = useState<TableSorting[]>([])

    const [fill, setFill] = useState<Fillter>({})

    return (
        <DataContext.Provider value={{
            data,
            setData,
            fill,
            setFill,
            activeColumn,
            setActiveColumn
        }}>
            {params.children}
        </DataContext.Provider>
    )
}